"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiImageUploadPanel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const core_1 = require("@athena-portal/core");
const Types_1 = require("../Types");
const operators_1 = require("rxjs/operators");
const index_1 = require("../index");
const imageSizeLimit = 10485760;
class MultiImageUploadPanel extends React.Component {
    constructor(props) {
        super(props);
        this.handleImageRemove = (image) => {
            this.handleRequest(this.falconConvenienceApiService.deleteImage(this.props.reference, image.id));
        };
        this.renderImages = () => {
            return this.state.images.map((image, index) => (this.renderImage(image)));
        };
        this.renderImageUploader = () => {
            const uploaderDisabled = this.state.images.length >= this.props.numberOfImages;
            const plusIcon = uploaderDisabled ? "plus-gray.svg" : "plus-white.svg";
            const btnClass = "btn-add-file ".concat(uploaderDisabled ? "btn-disabled" : "");
            return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "image-uploader-btn", children: [(0, jsx_runtime_1.jsxs)("label", { className: btnClass, htmlFor: "item-image-upload-input", children: [(0, jsx_runtime_1.jsx)("img", { alt: "Plus icon", src: `/${index_1.resourcesHelper.THEME}/img/`.concat(plusIcon) }), (0, jsx_runtime_1.jsx)("span", { children: "Add file" })] }), (0, jsx_runtime_1.jsx)("input", { type: "file", id: "item-image-upload-input", accept: ".jpg, .jpeg, .png", className: "d-none", disabled: uploaderDisabled, onChange: this.getFile })] }) }));
        };
        this.getFile = (event) => __awaiter(this, void 0, void 0, function* () {
            const imageFile = event.target.files[0];
            const imageSize = imageFile.size;
            const imageSizeTooLarge = imageSize > imageSizeLimit;
            this.setState({ imageError: undefined });
            if (imageFile) {
                if (imageSizeTooLarge) {
                    this.setState({
                        showOverlay: false,
                        imageError: "Please upload an image that’s under 10MB"
                    });
                    return;
                }
                event.preventDefault();
                this.setState({ showOverlay: true });
                const filename = imageFile.name;
                let compressedFile = null;
                try {
                    compressedFile = yield this.props.compressImage(imageFile);
                }
                catch (e) {
                    this.setState({
                        showOverlay: false,
                        imageError: "Oops, you’ve uploaded invalid image type. Try again using .jpg, .jpeg, .png"
                    });
                }
                if (compressedFile) {
                    const reader = new FileReader;
                    reader.readAsDataURL(compressedFile);
                    reader.onload = () => {
                        const base64 = reader.result;
                        const duplicate = this.state.images.find(image => {
                            return base64 === image.imageBase64;
                        });
                        this.setState({ showOverlay: false });
                        if (duplicate) {
                            return;
                        }
                        this.handleImageUpload(base64, filename);
                    };
                }
            }
        });
        this.state = {
            images: [],
            imageError: undefined,
            showOverlay: false,
            nonSavedImagesIds: [],
            uploadImageCalled: false
        };
        this.fetchImages();
    }
    render() {
        if (this.props.removeNewAddedImages === true) {
            this.removeUnsavedImagesAndClose();
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "form-group image-uploader-container", children: [this.props.headerBlock && this.props.headerBlock(), this.props.footerBlock && this.props.footerBlock(), this.renderImageUploader(), this.renderImages(), this.state.showOverlay && this.props.overlay && this.props.overlay(), !!this.state.imageError && ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block p-2 text-center", children: (0, jsx_runtime_1.jsx)("b", { children: this.state.imageError }) }))] }) }));
    }
    removeUnsavedImagesAndClose() {
        for (const id of this.state.nonSavedImagesIds) {
            this.handleRequest(this.falconConvenienceApiService.deleteImage(this.props.reference, id));
        }
        this.props.toggleParentModalClose && this.props.toggleParentModalClose();
    }
    fetchImages() {
        this.handleRequest(this.falconConvenienceApiService.getImages(this.props.reference));
    }
    handleImageUpload(base64Image, filename) {
        this.setState({
            uploadImageCalled: true
        });
        this.handleRequest(this.falconConvenienceApiService.postImage(this.props.reference, base64Image, filename));
    }
    handleRequest(observable) {
        if (this.state.showOverlay) {
            return;
        }
        this.setState({ showOverlay: true });
        observable
            .pipe((0, operators_1.finalize)(() => {
            this.setState({ showOverlay: false });
        }))
            .subscribe((images) => {
            if (this.state.uploadImageCalled === true) {
                if (this.state.images.length < images.length) {
                    this.state.nonSavedImagesIds.push(images[images.length - 1].id);
                }
                this.setState({
                    uploadImageCalled: false
                });
            }
            this.setState({ images, showOverlay: false });
            this.onChange(images);
        });
    }
    renderImage(image) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "image-uploader-item", children: [(0, jsx_runtime_1.jsx)("p", { children: (image === null || image === void 0 ? void 0 : image.filename) ? image.filename : "Untitled image" }), (0, jsx_runtime_1.jsxs)("div", { className: "image-uploader-item-close", onClick: () => this.handleImageRemove(image), children: [(0, jsx_runtime_1.jsx)("b", { className: "text-decoration-underline", children: "Delete" }), (0, jsx_runtime_1.jsx)("img", { src: `/${index_1.resourcesHelper.THEME}/img/`.concat("delete-icon.svg"), alt: "Delete image icon" })] })] }) });
    }
    onChange(images) {
        const uploadInput = document.getElementById("item-image-upload-input");
        if (uploadInput !== null) {
            // @ts-ignore
            document.getElementById("item-image-upload-input").value = "";
        }
        if (this.props.onChange) {
            this.props.onChange(images);
        }
    }
}
exports.MultiImageUploadPanel = MultiImageUploadPanel;
__decorate([
    (0, core_1.lazyInject)(Types_1.Types.FalconConvenienceApiService),
    __metadata("design:type", Object)
], MultiImageUploadPanel.prototype, "falconConvenienceApiService", void 0);
//# sourceMappingURL=MultiImageUploadPanel.js.map